module.exports = __webpack_public_path__ + "static/media/eye_close.98b6aae9.svg";